module.exports = __webpack_public_path__ + "static/media/Cityscape-Roma.4d5c96a9.jpg";